import { SelectOption } from "../../components/common/PL/Select/Select";

/** Opción de ubicación tal como la define el negocio: id corto + nombre para mostrar. */
export type LocationOption = { id: string; nombre: string };

/** Único país con provincias cargadas: al elegirlo se pide además la provincia. */
export const PAIS_ARGENTINA_ID = "ARG";

/** Países de procedencia (entrada) / destino (salida) de un transporte. Ids ISO 3166-1 alpha-3. */
export const paisesLatam: LocationOption[] = [
  { id: "ARG", nombre: "Argentina" },
  { id: "BOL", nombre: "Bolivia" },
  { id: "BRA", nombre: "Brasil" },
  { id: "CHL", nombre: "Chile" },
  { id: "COL", nombre: "Colombia" },
  { id: "CRI", nombre: "Costa Rica" },
  { id: "CUB", nombre: "Cuba" },
  { id: "DOM", nombre: "República Dominicana" },
  { id: "ECU", nombre: "Ecuador" },
  { id: "SLV", nombre: "El Salvador" },
  { id: "GTM", nombre: "Guatemala" },
  { id: "HND", nombre: "Honduras" },
  { id: "MEX", nombre: "México" },
  { id: "NIC", nombre: "Nicaragua" },
  { id: "PAN", nombre: "Panamá" },
  { id: "PRY", nombre: "Paraguay" },
  { id: "PER", nombre: "Perú" },
  { id: "PRI", nombre: "Puerto Rico" },
  { id: "URY", nombre: "Uruguay" },
  { id: "VEN", nombre: "Venezuela" },
];

export const provinciasArgentina: LocationOption[] = [
  { id: "BUE", nombre: "Buenos Aires" },
  { id: "CBA", nombre: "Córdoba" },
  { id: "CTA", nombre: "Catamarca" },
  { id: "CHA", nombre: "Chaco" },
  { id: "CHU", nombre: "Chubut" },
  { id: "CAB", nombre: "Ciudad Autónoma de Buenos Aires" },
  { id: "COR", nombre: "Corrientes" },
  { id: "ERI", nombre: "Entre Ríos" },
  { id: "FOR", nombre: "Formosa" },
  { id: "JUJ", nombre: "Jujuy" },
  { id: "LPA", nombre: "La Pampa" },
  { id: "LRI", nombre: "La Rioja" },
  { id: "MEN", nombre: "Mendoza" },
  { id: "MIS", nombre: "Misiones" },
  { id: "NEU", nombre: "Neuquén" },
  { id: "RNE", nombre: "Río Negro" },
  { id: "SAL", nombre: "Salta" },
  { id: "SJU", nombre: "San Juan" },
  { id: "SLU", nombre: "San Luis" },
  { id: "SCR", nombre: "Santa Cruz" },
  { id: "SFE", nombre: "Santa Fe" },
  { id: "SDE", nombre: "Santiago del Estero" },
  { id: "TDF", nombre: "Tierra del Fuego, Antártida e Islas del Atlántico Sur" },
  { id: "TUC", nombre: "Tucumán" },
];

/** Los `Select` compartidos consumen `{ value, label }`. */
export const toSelectOptions = (items: LocationOption[]): SelectOption[] =>
  items.map(({ id, nombre }) => ({ value: id, label: nombre }));

/** Procedencia / destino de un transporte, tal como viajan en el evento. */
export type TransportLocation = {
  country?: string | null;
  province?: string | null;
};

/** Si el id no está en la lista mostramos el id crudo antes que un vacío. */
const nombrePorId = (items: LocationOption[], id?: string | null): string =>
  id ? items.find((item) => item.id === id)?.nombre ?? id : "";

/**
 * "Provincia, País" para mostrar en tablas. La provincia sólo se carga para Argentina, así que
 * el resto de los países quedan con el nombre del país solo.
 */
export const formatTransportLocation = (
  location?: TransportLocation | null
): string | undefined => {
  const pais = nombrePorId(paisesLatam, location?.country);
  const provincia = nombrePorId(provinciasArgentina, location?.province);
  return [provincia, pais].filter(Boolean).join(", ") || undefined;
};

export const paisesLatamOptions = toSelectOptions(paisesLatam);
export const provinciasArgentinaOptions = toSelectOptions(provinciasArgentina);
